import React from 'react';

export default function FisheryManagement({
  selectedTile,
  userId,
  landRoutes,
  toggleLandRoute,
  isLandConnected,
  getOwnedMarkets,
  routeLimit,
  getTileUpgradeLevel,
  getMaxRoutes,
  getTradePartnerMarkets, // New prop to get trade partner's markets
  getEquipmentUpgradeLevel,
  getEquipmentMultiplier
}) {
  if (!selectedTile || selectedTile.type !== 6 || !selectedTile.owner || selectedTile.owner.owner !== userId) {
    return null;
  }

  const upgradeLevel = getTileUpgradeLevel ? getTileUpgradeLevel(selectedTile.key) : 0;
  const equipmentLevel = getEquipmentUpgradeLevel ? getEquipmentUpgradeLevel(selectedTile.key) : 0;
  const equipmentMultiplier = getEquipmentMultiplier ? getEquipmentMultiplier(equipmentLevel) : 1.0;
  const maxRoutes = getMaxRoutes ? getMaxRoutes(upgradeLevel) : routeLimit;
  const currentConnections = (landRoutes[selectedTile.key] || []).length;
  const isAtLimit = currentConnections >= maxRoutes;

  // Ensure we get fresh trade partner markets each render
  const ownedMarkets = getOwnedMarkets();
  const tradePartnerMarkets = getTradePartnerMarkets ? getTradePartnerMarkets() : [];
  const allAvailableMarkets = [...ownedMarkets, ...tradePartnerMarkets];

  const getEquipmentBenefitText = () => {
    if (equipmentLevel === 0) return null;
    const percentage = ((equipmentMultiplier - 1) * 100).toFixed(0);
    return `+${percentage}% income & costs (Equipment Lv${equipmentLevel})`;
  };

  return (
    <div style={{
      marginBottom: '15px',
      padding: '10px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '5px',
      border: '1px solid rgba(255, 255, 255, 0.3)'
    }}>
      <h5 style={{ margin: '0 0 10px 0', fontSize: '0.85em', color: '#E8F5E8', wordWrap: 'break-word' }}>
        🐟 Fishery-Market Connections
      </h5>
      
      {allAvailableMarkets.length === 0 ? (
        <div style={{ 
          fontSize: '0.75em', 
          color: 'rgba(255, 255, 255, 0.7)',
          textAlign: 'center',
          fontStyle: 'italic',
          wordWrap: 'break-word'
        }}>
          You need to own markets or have a trade agreement to connect this fishery
        </div>
      ) : (
        <div>
          <div style={{ fontSize: '0.75em', color: '#C8E6C9', marginBottom: '8px', wordWrap: 'break-word' }}>
            Select markets to connect with:
          </div>
          {allAvailableMarkets.map(market => {
            const isConnected = isLandConnected(selectedTile.key, market.key);
            const isDisabled = !isConnected && isAtLimit;
            const isTradePartner = !ownedMarkets.some(m => m.key === market.key);
            
            return (
              <div key={market.key} style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '5px',
                fontSize: '0.75em',
                opacity: isDisabled ? 0.5 : 1
              }}>
                <input
                  type="checkbox"
                  id={`fishery-route-${market.key}`}
                  checked={isConnected}
                  disabled={isDisabled}
                  onChange={() => toggleLandRoute(selectedTile.key, market.key)}
                  style={{
                    marginRight: '8px',
                    cursor: isDisabled ? 'not-allowed' : 'pointer'
                  }}
                />
                <label 
                  htmlFor={`fishery-route-${market.key}`}
                  style={{ 
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                    color: isConnected ? '#90EE90' : (isDisabled ? 'rgba(255, 255, 255, 0.5)' : 'white'),
                    wordWrap: 'break-word',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <span style={{ flex: 1 }}>
                    {market.name}
                    {isConnected && ' ✓'}
                  </span>
                  {isTradePartner && (
                    <span style={{ 
                      fontSize: '0.7em', 
                      color: '#9C27B0', 
                      marginLeft: '4px',
                      fontWeight: 'bold'
                    }}>
                      🤝
                    </span>
                  )}
                </label>
              </div>
            );
          })}
          
          <div style={{
            marginTop: '10px',
            fontSize: '0.7em',
            color: 'rgba(255, 255, 255, 0.6)',
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            paddingTop: '5px',
            wordWrap: 'break-word'
          }}>
            Connected markets: {currentConnections}/{maxRoutes}
            {upgradeLevel > 0 && (
              <div style={{ color: '#90EE90', fontSize: '0.65em', marginTop: '2px' }}>
                Upgraded (Level {upgradeLevel})
              </div>
            )}
            {equipmentLevel > 0 && (
              <div style={{ color: '#FFD700', fontSize: '0.65em', marginTop: '2px' }}>
                {getEquipmentBenefitText()}
              </div>
            )}
            {isAtLimit && (
              <div style={{ color: '#FFB74D', fontSize: '0.65em', marginTop: '2px' }}>
                Maximum connections reached
              </div>
            )}
            {tradePartnerMarkets.length > 0 && (
              <div style={{ color: '#9C27B0', fontSize: '0.65em', marginTop: '2px' }}>
                🤝 = Trade partner's property
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}